import styled from "styled-components";

export const Card = styled.div`
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
`;

export const SectionTitle = styled.h5`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
`;

export const IconGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const IconOption = styled.button<{
    isActive: boolean;
    mainColor: string;
}>`
    width: 44px;
    height: 44px;
    border-radius: 8px;
    border: 2px solid
        ${({ isActive, mainColor }) => (isActive ? mainColor : "#e0e0e0")};
    background-color: ${({ isActive, mainColor }) =>
        isActive ? `${mainColor}15` : "#fff"};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    svg {
        width: 22px;
        height: 22px;
        fill: ${({ isActive, mainColor }) => (isActive ? mainColor : "#666")};
    }

    &:hover {
        border-color: ${({ mainColor }) => mainColor};
        background-color: ${({ mainColor }) => `${mainColor}10`};
    }
`;

export const IconUploadButton = styled.button<{
    mainColor: string;
    hasImage: boolean;
    isActive?: boolean;
}>`
    width: 44px;
    height: 44px;
    border-radius: 8px;
    border: ${({ isActive, hasImage, mainColor }) =>
        isActive
            ? `2px solid ${mainColor}`
            : `2px dashed ${hasImage ? mainColor : "#ccc"}`};
    background-color: ${({ isActive, hasImage, mainColor }) =>
        isActive ? `${mainColor}25` : hasImage ? `${mainColor}15` : "#fafafa"};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    overflow: hidden;
    padding: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    svg {
        width: 20px;
        height: 20px;
        fill: ${({ isActive, mainColor }) => (isActive ? mainColor : "#999")};
    }

    &:hover {
        border-color: ${({ mainColor }) => mainColor};
        background-color: ${({ mainColor }) => `${mainColor}10`};
    }
`;

export const IconUploadWrapper = styled.div`
    position: relative;
    display: inline-flex;
`;

export const IconDeleteBadge = styled.button<{ mainColor: string }>`
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #ff4444;
    border: 2px solid white;
    color: white;
    font-size: 10px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    z-index: 1;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #cc0000;
    }
`;

export const IconDimensions = styled.span`
    font-size: 11px;
    color: #999;
    margin-left: 4px;
`;
